var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormRole", {
                attrs: {
                  data: _vm.role,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                },
                on: {
                  submit: _vm.roleSubmitHandle,
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-roles" })
                  },
                  "delete-role": _vm.deleteRole,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmRoleRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }